import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OwnersService } from 'app/services/owners.service';
import { fuseAnimations } from '@fuse/animations';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray } from '@angular/forms';
import * as _ from 'lodash';
import { map } from 'lodash';
import { Owners } from 'app/models/owners';
import { CrmMenuService } from 'app/services/crm-menu.service';
import { CommercialPropertiesService } from 'app/services/commercial-properties.service';
import { GlobalFuntions } from 'app/_helpers';
import { AuthenticationService } from 'app/services';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'owners-create',
    templateUrl: './owners-create.component.html',
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class OwnersCreateComponent implements OnInit, OnDestroy {
    form: UntypedFormGroup;
    _owner: Owners;
    id: string;
    title = '';
    /**
     * Constructor
     *
     * @param {FormBuilder} _formBuilder
     */
    private _unsubscribeAll: Subject<any>;
    viewRecord: boolean;
    index: any;
    subRouts: { label: string; path: string; index: number }[];
    customSettings: UntypedFormArray;
    financialAccounts: UntypedFormArray;
    partners: UntypedFormArray;
    officeData: any;
    currentUser: any;
    previousUrl = '/master-data/owners';
    pOwners: BehaviorSubject<any> = new BehaviorSubject<any>([]);

    constructor(
        private _ownersService: OwnersService,
        private _crmMenuService: CrmMenuService,
        private _commercialPropertiesService: CommercialPropertiesService,
        private _formBuilder: UntypedFormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private _authenticationService: AuthenticationService,
        private _globalFunctions: GlobalFuntions,
        private _translateService: TranslateService,
        private _snackBar: MatSnackBar
    ) {
        this.currentUser = this._authenticationService.currentUserValue;
        this.officeData = this._authenticationService.currentOfficeValue;
        if (window.history.state) {
            if (window.history.state.route) {
                let previousUrl = window.history.state.route;
                if (previousUrl.indexOf('?') > -1) {
                    previousUrl = previousUrl.substring(
                        0,
                        previousUrl.indexOf('?')
                    );
                }
                this.previousUrl = previousUrl;
            } else {
                this.previousUrl = '/master-data/owners';
            }
        }

        this.id = this.route.snapshot.paramMap.get('id');
        this.subRouts = [
            {
                label: 'id',
                path: './id',
                index: 0,
            },
            {
                label: 'contact',
                path: './contact',
                index: 1,
            },
            {
                label: 'notes',
                path: './notes',
                index: 5,
            },
            {
                label: 'document',
                path: './document',
                index: 6,
            },
            {
                label: 'history',
                path: './history',
                index: 7,
            },
            {
                label: 'agency',
                path: './agency',
                index: 8,
            },
            {
                label: 'audit',
                path: './audit',
                index: 9,
            },
        ];
        if (this._crmMenuService.isPropertyModule) {
            this.subRouts.push({
                label: 'properties',
                path: './properties',
                index: 2,
            });
        }
        if (this._crmMenuService.isCommercialModule) {
            this.subRouts.push({
                label: 'commercial-properties',
                path: './commercial-properties',
                index: 3,
            });
        }
        if (this._crmMenuService.isMooringModule && this._crmMenuService.isBoatModule) {
            this.subRouts.push({
                label: 'moorings-and-boats',
                path: './moorings-and-boats',
                index: 4,
            });
        }
        let viewRecord = false;
        let officeRecord = false;
        if (_.includes(this.router.url, 'view')) {
            viewRecord = true;
            officeRecord = true;
        }

        if (this._globalFunctions.getUserRole(this.currentUser.user_role)) {
            officeRecord = true;
        }

        if (!this?.currentUser?.user_master_office) {
            officeRecord = true;
        }
        this.form = this._formBuilder.group({
            _id: [],
            id: [{ value: '', disabled: true }],
            type: [{ value: '', disabled: viewRecord }],
            classification: [{ value: '', disabled: viewRecord }],
            forename: [
                { value: '', disabled: viewRecord },
                Validators.required,
            ],
            surname: [{ value: '', disabled: viewRecord }, Validators.required],
            date_of_birth: [{ value: '', disabled: viewRecord }],
            birthday_greetings: [{ value: '', disabled: viewRecord }],
            age: [{ value: '', disabled: viewRecord }],
            civil_status: [{ value: '', disabled: viewRecord }],
            children: [{ value: '', disabled: viewRecord }],
            document_type: [{ value: '', disabled: viewRecord }],
            document_number: [
                { value: '', disabled: viewRecord },
                Validators.required,
            ],
            document_type_two: [{ value: '', disabled: viewRecord }],
            document_number_two: [
                { value: '', disabled: viewRecord },
                Validators.required,
            ],
            search: [{ value: '', disabled: viewRecord }],
            home_phone: [{ value: '', disabled: viewRecord }],
            work_phone: [{ value: '', disabled: viewRecord }],
            mobile: [{ value: '', disabled: viewRecord }, Validators.required],
            secondary_mobile: [{ value: '', disabled: viewRecord }],
            secondary_home_phone: [{ value: '', disabled: viewRecord }],
            secondary_work_phone: [{ value: '', disabled: viewRecord }],
            email: [{ value: '', disabled: viewRecord }, Validators.required],
            skype_id: [{ value: '', disabled: viewRecord }],
            title: [{ value: '', disabled: viewRecord }],
            gender: [{ value: '', disabled: viewRecord }],
            street: [{ value: '', disabled: viewRecord }],
            streetnumber: [{ value: '', disabled: viewRecord }],
            comments: [{ value: '', disabled: viewRecord }],
            source: [{ value: '', disabled: viewRecord }],
            gdpr_comment: [{ value: '', disabled: viewRecord }],
            options: [{ value: '', disabled: viewRecord }],
            complete_address: [{ value: '', disabled: viewRecord }],
            complete_address_country: [{ value: '', disabled: viewRecord }],
            complete_address_region: [{ value: '', disabled: viewRecord }],
            complete_address_city: [{ value: '', disabled: viewRecord }],
            postcode: [{ value: '', disabled: viewRecord }],
            complete_address_province: [{ value: '', disabled: viewRecord }],
            status: [{ value: '', disabled: viewRecord }],
            regionSearch: [{ value: '', disabled: viewRecord }],
            listing: this._formBuilder.array([]),
            custom_settings: this._formBuilder.array([]),
            financial_accounts: this._formBuilder.array([]),
            account_holder: [{ value: '', disabled: viewRecord }],
            bic_swift: [{ value: '', disabled: viewRecord }],
            iban: [{ value: '', disabled: viewRecord }],
            avg_balance: [{ value: '', disabled: viewRecord }],
            key: [{ value: '', disabled: viewRecord }],
            linked_users: [{ value: '', disabled: viewRecord }],
            value: [{ value: '', disabled: viewRecord }],
            company_name: [
                { value: '', disabled: viewRecord },
                Validators.required,
            ],
            legal_form: [
                { value: '', disabled: viewRecord },
                Validators.required,
            ],
            currency: [{ value: '', disabled: viewRecord }],
            tax_id: [{ value: '', disabled: viewRecord }, Validators.required],
            nationality: [{ value: '', disabled: viewRecord }],
            language: [{ value: '', disabled: viewRecord }],
            language_value: [{ value: '', disabled: viewRecord }],
            address: [{ value: '', disabled: viewRecord }],
            region: [{ value: '', disabled: viewRecord }],
            country: [{ value: '', disabled: viewRecord }],
            province: [{ value: '', disabled: viewRecord }],
            city: [{ value: '', disabled: viewRecord }],
            properties: [{ value: '', disabled: viewRecord }],
            commercial_properties: [{ value: '', disabled: viewRecord }],
            moorings: [{ value: '', disabled: viewRecord }],
            boats: [{ value: '', disabled: viewRecord }],
            communication_language: [{ value: '', disabled: viewRecord }],
            offices: [{ value: [this.officeData._id], disabled: officeRecord }],
            probability: [{ value: '', disabled: viewRecord }],
            invoice_series: [{ value: '', disabled: viewRecord }],
            gdpr_status: [{ value: '', disabled: viewRecord }],
            company: [{ value: '', disabled: viewRecord }],
            company_contact: [{ value: '', disabled: viewRecord }],
            partners: this._formBuilder.array([]),
            automated_email: [{ value: '', disabled: viewRecord }],
            newsletter: [{ value: '', disabled: viewRecord }],
            lead_status: [{ value: '', disabled: viewRecord }],
            assign_agent: [{ value: '', disabled: viewRecord }],
            accounting_code: [{ value: '', disabled: viewRecord }],
            payment_method: { value: '', disabled: this.viewRecord },
        });
        this.customSettings = this.form.get('custom_settings') as UntypedFormArray;
        this.financialAccounts = this.form.get(
            'financial_accounts'
        ) as UntypedFormArray;
        this.partners = this.form.get('partners') as UntypedFormArray;
    }

    ngOnInit(): void {
        if (this.id) {
            this._ownersService.getById(this.id).subscribe((owner: any) => {
                if (!owner.custom_settings) {
                    owner.custom_settings = [];
                }
                if (!owner.financial_accounts) {
                    owner.financial_accounts = [];
                }
                if (!owner.partners) {
                    owner.partners = [];
                }
                this.setCivilStatus(owner);
                if (_.isArray(owner.mobile)) {
                    owner.mobile = owner.mobile.toString();
                }
                if(owner?.linked_users_data && !owner?.linked_users) {
                    owner.linked_users = owner.linked_users_data?._id;
                    this.form.get('linked_users').setValue(owner.linked_users)
                }
                this.form.patchValue(owner);
                // this.title = 'Update Owner';
                if (
                    this.form.get('type').value === 'individual' ||
                    this.form.get('type').value === 'family'
                ) {
                    console.log('get by id');
                    this.form
                        .get('age')
                        .setValue(
                            this.calculateAge(
                                this.form.get('date_of_birth').value || 0
                            )
                        );
                    this.title =
                        this.title +
                        ' ' +
                        this.form.get('forename').value +
                        ' ' +
                        this.form.get('surname').value;
                    if (this.form.get('id')) {
                        this.title =
                            this.title +
                            ' (O-' +
                            this.form.get('id').value +
                            ')';
                    }
                } else if (this.form.get('type').value === 'company') {
                    this.title =
                        this.title + ' ' + this.form.get('company_name').value;
                    if (this.form.get('id')) {
                        this.title =
                            this.title +
                            ' (O-' +
                            this.form.get('id').value +
                            ')';
                    }
                }
                if (
                    owner.custom_settings &&
                    !_.isEmpty(owner.custom_settings) &&
                    owner.custom_settings.length
                ) {
                    this.clearFormArray(this.customSettings);
                    _.forEach(owner.custom_settings, (setting, key) => {
                        this.customSettings.push(this.createCustomSettings());
                        this.form
                            .get('custom_settings.' + key)
                            .patchValue(setting);
                    });
                }
                if (
                    owner.financial_accounts &&
                    !_.isEmpty(owner.financial_accounts) &&
                    owner.financial_accounts.length
                ) {
                    this.clearFormArray(this.financialAccounts);
                    _.forEach(owner.financial_accounts, (setting, key) => {
                        this.financialAccounts.push(
                            this.createFinancialAcoounts()
                        );
                        this.form
                            .get('financial_accounts.' + key)
                            .patchValue(setting);
                    });
                }
                if (
                    owner.partners &&
                    !_.isEmpty(owner.partners) &&
                    owner.partners.length
                ) {
                    this.clearFormArray(this.partners);
                    _.forEach(owner.partners, (setting, key) => {
                        this.partners.push(this.createPartners());
                        this.form.get('partners.' + key).patchValue(setting);
                        this.form
                            .get('partners.' + key + '.age')
                            .setValue(
                                this.calculateAge(
                                    this.form.get(
                                        'partners.' + key + '.date_of_birth'
                                    ).value
                                )
                            );
                    });
                }
                if (owner.address && owner.address.formatted_address) {
                    this.form
                        .get('address')
                        .setValue(owner.address.formatted_address);
                }
                if (owner.properties && owner.properties.length > 0) {
                    this.form.get('properties').setValue(owner.properties);
                    this.pOwners.next(owner.properties)
                }

                const query = {
                    $or: [
                        {
                            owner: owner._id,
                        },
                    ],
                } as any;
                if (owner.commercial_properties) {
                    query.$or.push({
                        reference: {
                            $in: owner.commercial_properties,
                        },
                    });
                }
                this._commercialPropertiesService
                    .commercialPropertiesByOwner(query)
                    .subscribe((data) => {
                        if (data) {
                            this.form
                                .get('commercial_properties')
                                .setValue(map(data, 'reference'));
                        }
                    });
                // if (owner.properties && owner.properties.length > 0) {
                //     this._ownersService
                //         .getPropertiesOwner(owner)
                //         .subscribe((data: any) => {
                //             if (data) {
                //                 console.log(data);
                //                 this.form
                //                     .get('properties')
                //                     .setValue(map(data, 'reference'));
                //                 this.pOwners.next(data);
                //             }
                //         });
                // }
            });
        }
    }
    submitForm(action): void {
        if (this.id) {
            this.form.value._id = this.id;
            let properties: any;
            if (this.form.get('properties').value) {
                properties = this.form.get('properties').value;
            }
            const formData = this.form.value;
            if (properties) {
                formData.properties = properties;
            }
            const postObj = this._globalFunctions.cleanObject(formData);
            this._ownersService.update(postObj).subscribe((owners: any) => {
                this._snackBar.open(
                    this._translateService.instant('Updated successfully'),
                    this._translateService.instant('Close'),
                    {
                        duration: 2000,
                    }
                );
                if (action === 'close') {
                    this.router.navigate([this.previousUrl], {
                        queryParams: { previousSearch: true },
                    });
                }
            });
        } else {
            this._ownersService
                .create(this._globalFunctions.cleanObject(this.form.value))
                .subscribe((data: any) => {
                    if (action === 'close') {
                        this.router.navigate([this.previousUrl], {
                            queryParams: { previousSearch: true },
                        });
                    } else {
                        this.router.navigate([
                            '/master-data/owners/update/' + data._id,
                        ]);
                    }
                });
        }
    }

    ngOnDestroy(): void {}
    createFinancialAcoounts(): UntypedFormGroup {
        return this._formBuilder.group({
            account_holder: [{ value: '', disabled: false }],
            iban: [{ value: null, disabled: false }],
            bic_swift: [{ value: '', disabled: false }],
            avg_balance: [{ value: '', disabled: false }],
            account_currency: [{ value: '', disabled: false }],
        });
    }

    createCustomSettings(): UntypedFormGroup {
        return this._formBuilder.group({
            key: [{ value: '', disabled: false }],
            value: [{ value: '', disabled: false }],
        });
    }

    createPartners(): UntypedFormGroup {
        return this._formBuilder.group({
            title: { value: '', disabled: false },
            forename: { value: '', disabled: false },
            surname: { value: '', disabled: false },
            date_of_birth: { value: '', disabled: false },
            age: { value: '', disabled: true },
            civil_status: { value: '', disabled: false },
            nationality: { value: '', disabled: false },
            document_type: { value: '', disabled: false },
            document_number: { value: '', disabled: false },
            document_type_two: { value: '', disabled: false },
            document_number_two: { value: '', disabled: false },
            gender: { value: '', disabled: false },
            phone: { value: '', disabled: false },
            email: { value: '', disabled: false },
            children: { value: '', disabled: false },
        });
    }

    clearFormArray = (formArray: UntypedFormArray) => {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    };
    calculateAge(dateOfBirth): any {
        const today = new Date();
        const birthDate = new Date(dateOfBirth);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }
    gotoUser(): void {
        this.router.navigate(['/users/create']);
    }
    createAccount(): void {
        this._ownersService
            .insertCoustomAccount(this.form.value)
            .subscribe((response: any) => {
                this.router.navigate([
                    '/master-data/accounts/update/' + response._id,
                ]);
            });
    }
    setCivilStatus(owner) {
        if(owner?.partners?.length > 0) {
            for (const partner of owner.partners) {
                if(partner?.civil_status == "married") {
                    partner.civil_status = "Married";
                }
            }
        }
    }
}
